// removed by extract-text-webpack-plugin
module.exports = {"container":"_3io_kYrUkZQBc_m6WBChpk","title":"kABPFRkVfU22coQ1yh_B5","subtitle":"_3kjZa2jP95Z7qTsCnnz20J","formWrapper":"_1D0Ws0xbMj2XV2w3Svi8pe","formRow":"_1gYY3SCflY0w-IV7waVyg9","label":"_2oUQTV4ixyUJARSbeon37I","block":"_2o4QBAfcKaIQ87wmcys4Wp","submitWrapper":"_2VCSxCzlEGkD-XN6Zf9Zab","close":"aSEBw5ukqtSUyCOaeQlbp","processModal":"dfCiPdnfw3Y6K9YlG31wJ","processOverlay":"_3JosXjmrN9M1GP99vMVLi0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeedbackIncreaseLimits/FeedbackIncreaseLimits.scss
// module id = 773
// module chunks = 0